import {
    ChannelViewProps,
} from './types'
import Chat from '../Chat'
import React from 'react'

const ChannelView = ({
    chat,
    isAudienceChannel,
    isVideoChannel,
    realm_id,
    queue_id,
}: ChannelViewProps): React.ReactElement => (
    <Chat
        chat={chat}
        isAudienceChannel={isAudienceChannel}
        isVideoChannel={isVideoChannel}
        queue_id={queue_id}
        realm_id={realm_id}
    />
)

export default ChannelView
